export class HeaderCatalog {
	constructor(element) {
		if (!element) return;
		this.element = element;
		this.categoriesElement = this.element.querySelector('.header-catalog__categories');
		this.innerElement = this.element.querySelector('.header-catalog__categories-inner');
		this.items = this.element.querySelectorAll('.header-catalog__category');

		this.init();
	}

	tuneHeight = () => {
		if (this.categoriesElement.scrollWidth > this.categoriesElement.offsetWidth) {
			const height = parseInt(this.innerElement.style.getPropertyValue('height'), 10) + 10;
			this.innerElement.style.setProperty('height', `${height}px`);
			requestAnimationFrame(this.tuneHeight);
		}
	};

	setHeight = () => {
		const heightSum = this.innerElement.offsetHeight;
		this.innerElement.style.setProperty('height', `${heightSum / 2}px`);
		this.tuneHeight();
	};

	init = () => {
		if (this.items.length) setTimeout(() => this.setHeight(), 1000);
	};
}
